import { cn } from '@/lib/utils'

import { Tabs, TabsList, TabsTrigger } from '../../ui/tabs'

type TabsSelectProps<T = string> = {
  value: T
  onChange: (_: T) => void
  options: Array<{
    name: string
    value: T
    hidden?: boolean
  }>
  className?: string
  color?: string
}

export const TabsSelect = <T extends string>({ value, onChange, options, className, color }: TabsSelectProps<T>) => {
  return (
    <Tabs
      value={value}
      onValueChange={(value: unknown) => onChange(value as T)}
    >
      <TabsList className={color}>
        {options.map(({ name, value, hidden }) => {
          if (hidden) {
            return null
          }

          return (
            <TabsTrigger
              key={value}
              value={value}
              className={cn('px-4 text-t-primary', className)}
            >
              {name}
            </TabsTrigger>
          )
        })}
      </TabsList>
    </Tabs>
  )
}
